import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { object, string } from 'yup';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import { CategoriaDeCurriculoLista } from 'Component/CategoriaDeCurriculo';
import Form, { Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarCategoriasDeCurriculoQuery } from 'View/Service/Default/CategoriasDeCurriculo';

const regras = object({
  busca: string().optional().min(3, 'Deve ter mais que 3 letras'),
});

const Default = (): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, refetch, isFetching, isLoading } =
    useRecuperarCategoriasDeCurriculoQuery({
      page: searchParams.get('pagina') || 1,
      options: { busca: { termo: searchParams.get('busca') || '' } },
    });

  const filtrar = (
    dados: { busca: string },
    form: FormikHelpers<FormikValues>
  ) => {
    searchParams.set('busca', dados.busca);
    searchParams.set('pagina', '1');

    setSearchParams(searchParams);

    form.setSubmitting(false);
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Categorias de currículo"
        descricao="Listagem de categorias de currículo cadastrados no banco de dados"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        regras={regras}
        desabilitado={isFetching}
      >
        <div className="row">
          <div className="col-md-6 mb-3">
            <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
            <BotaoLink
              tema="success"
              icone="plus-lg"
              to="/categorias-de-curriculo/adicionar"
            >
              Adicionar
            </BotaoLink>
          </div>
          <div className="col-md-6 mb-3">
            <div className="hstack gap-3">
              <Campo name="busca" rotulo="Digite o que deseja buscar" />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={data?.categorias.length}
        redirecionar="/categorias-de-curriculo/adicionar"
      />
      <div className="bg-white shadow-sm rounded">
        {data?.categorias?.map((categorias) => (
          <CategoriaDeCurriculoLista
            key={`${categorias.id}-${categorias.modificado}`}
            dados={categorias}
          />
        ))}
      </div>
      <Paginacao dados={data?.paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Default;
